const KEY = "santral_favorites";

export const getFavorites = () => {
  try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; }
};

export const isFavorite = (id) => getFavorites().includes(id);

export const toggleFavorite = (id) => {
  const list = getFavorites();
  const idx = list.indexOf(id);
  if (idx >= 0) list.splice(idx, 1); else list.push(id);
  localStorage.setItem(KEY, JSON.stringify(list));
  window.dispatchEvent(new Event("favorites-changed"));
  return list.includes(id);
};
